import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ApiProvider } from './api/ApiProvider';
import { CookieAuthProvider } from './auth/CookieAuthProvider';
import { MockAuthProvider } from './auth/MockAuthProvider';
import './global.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});

const useMockAuth = import.meta.env.VITE_MOCK_AUTH === 'true';
const AuthProvider = useMockAuth ? MockAuthProvider : CookieAuthProvider;

function bootstrap() {
	const rootEl = document.getElementById('root');
	if (!rootEl) throw new Error('Root element not found');

	createRoot(rootEl).render(
		<StrictMode>
			<AuthProvider>
				<QueryClientProvider client={queryClient}>
					<ApiProvider>
						<App />
					</ApiProvider>
				</QueryClientProvider>
			</AuthProvider>
		</StrictMode>,
	);
}

bootstrap();
